import ProductCard from './ProductCard';
import React from 'react';
const ProductsList = ({ products, isTeammate, translate }) => (
  <div className='products-list' style={{ width: '100%' }}>
    {products.map((product, index) => (
      <ProductCard key={product.id || index} product={product} index={index} isTeammate={isTeammate} translate={translate} />
    ))}
  </div>
);

export default ProductsList;
